module.exports = __webpack_public_path__ + "static/media/check-pending.eb4b4589.svg";